<template>
  <div id="Personaldetails">
    <el-dropdown trigger="click">
      <span class="el-dropdown-link"
        ><div class="oImg">
          <img :src="this.$store.state.homeitem.user.img" alt="" />
        </div>
        {{ list[0].idlist }}
      </span>
      <el-dropdown-menu class="add" slot="dropdown" split-button="true">
        <div class="colorthree"></div>
        <div class="my">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="个人信息" name="first">
              <div class="first-up">
                <ul class="up-left">
                  <li v-for="item in list" :key="item.id">
                    <p class="name">{{ item.fors }}</p>
                    <p>{{ item.idlist }}</p>
                  </li>
                </ul>
                <div class="up-right">
                  <el-upload
                    class="avatar-uploader"
                    action=""
                    :show-file-list="false"
                    :before-upload="beforeAvatarUpload"
                  >
                    <div id="logo">
                      <img
                        v-if="imageUrl !== ''"
                        :src="imageUrl"
                        class="avatar"
                      />
                      <img
                        v-else
                        :src="$store.state.homeitem.user.img"
                        alt=""
                      />
                    </div>
                    <el-button class="logo-btn" size="small">
                      修改头像</el-button
                    >
                  </el-upload>
                </div>
              </div>
              <div class="first-below" @click="btnclick">退出登录</div>
            </el-tab-pane>
            <el-tab-pane label="修改密码" name="second">
              <Succeed @itemShow="add" v-if="Isshow > 0"></Succeed>
              <el-form
                v-else
                label-position="left"
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100rem"
                class="demo-ruleForm"
              >
                <el-form-item label="旧密码:" prop="age">
                  <el-input
                    id="noingp1"
                    type="password"
                    v-model="ruleForm.age"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="新密码:" prop="pass">
                  <el-input
                    id="noingp2"
                    type="password"
                    v-model="ruleForm.pass"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="确认新密码:" prop="checkPass">
                  <el-input
                    id="noingp3"
                    type="password"
                    v-model="ruleForm.checkPass"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    id="btn"
                    type="primary"
                    @click="submitForm('ruleForm')"
                    >保存</el-button
                  >
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { play } from "../../api/login";
import Succeed from "./succeed";
import { UPDATE_AVATAR } from "../../api/upload";
export default {
  name: "Personaldetails",
  components: {
    Succeed,
  },
  data() {
    var checkAge = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("密码不能为空"));
      } else {
        if (this.ruleForm.age.length < 6 || this.ruleForm.age.length > 18) {
          callback(new Error("要求6-18位字符"));
        }
        if (this.ruleForm.age.match(/([\u4E00-\u9FA5])+/)) {
          callback(new Error("不能包含中文字符"));
        }

        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      var lts = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,18}$/;
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        if (this.ruleForm.pass.length < 6 || this.ruleForm.pass.length > 18) {
          callback(new Error("要求6-18位字符"));
        }
        if (this.ruleForm.pass.match(/([\u4E00-\u9FA5])+/)) {
          callback(new Error("不能包含中文字符"));
        }
        if (value == this.ruleForm.age) {
          callback(new Error("新密码与旧密码一致!"));
        }
        if (!lts.test(value)) {
          callback(new Error("必须包含数字，字母，特殊符号两种或以上！"));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      name: "",
      imageUrl: "",
      file: "",
      user: [],
      Isshow: 0,
      ruleForm: {
        age: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        age: [{ validator: checkAge, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },

      list: [
        { id: 1, fors: "姓名:", idlist: "" },
        { id: 2, fors: "手机:", idlist: "" },
        { id: 3, fors: "身份:", idlist: "" },
        { id: 4, fors: "工号:", idlist: "" },
        { id: 5, fors: "部门:", idlist: "" },
      ],

      activeName: "first",
    };
  },
  watch: {
    "$store.state.homeitem.user"(newval, olval) {
      this.user = newval;
    },
  },
  mounted() {
    // console.log(this.$store.state.homeitem.user.img);
    this.Userid();
  },
  methods: {
    //logo上传
    beforeAvatarUpload(file) {
    //   console.log(file);
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG和PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }

      UPDATE_AVATAR(file).then((res) => {
        // console.log(res);
        this.imageUrl = res.data.data.path;
        if (res.data.status) {
          this.$store.state.homeitem.user.img = res.data.data.path;
        }
      });

      return false;
      // return isJPG && isLt2M;
    }, //上传

    add(val) {
      this.Isshow = val;
    },
    Userid() {
      this.user = this.$store.state.homeitem.user?this.$store.state.homeitem.user:"- -";
    //   console.log(this.user);
      this.list[0].idlist = this.user.realName?this.user.realName:"- -";
      this.list[1].idlist = this.user.tel?this.user.tel:"- -";
      this.list[2].idlist = this.user.roleDesc? this.user.roleDesc:"- -";
      this.list[3].idlist = this.user.jobNumber?this.user.jobNumber:"- -";
      // this.list[3].idlist = this.user.roleDes
      this.list[4].idlist = this.user.deptName?this.user.deptName:"- -";
      // console.log(this.user, "个人信息");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          play.loginpass(this.ruleForm.pass, this.ruleForm.age).then((res) => {
            if (res.data.status) {
              this.Isshow = 1;
              this.ruleForm.pass = "";
              this.ruleForm.age = "";
              this.ruleForm.checkPass = "";
            } else {
              this.$message.error("旧密码输入错误");
            }
          });
        } else {
          return false;
        }
      });
    },
    btnclick() {
      this.$router.push("/login");
      window.location.reload();
      window.localStorage.removeItem("storelt");
      window.sessionStorage.removeItem("loginId");
      window.sessionStorage.removeItem("homeLogin");
      // //刷新数据
      window.sessionStorage.clear();
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="less" scoped>
.add {
  
  box-shadow: 10rem 10rem 30rem 10rem rgba(0, 43, 102, 0.28);
  width: 400px !important;
  height: auto !important;
  padding: 0 10rem 20rem 10rem;

  .el-form-item {
    width: 300px;
    margin: auto;
    margin-top: 20px !important;
  }
  .el-input__inner {
    width: 196px !important;
    height: 40px !important;
  }
  #noingp2 {
    width: 196px !important;
    height: 40px !important;
  }
  .my {
    // width: 400rem;
    height: auto;
    background-color: #ffff;

    .first-up {
      display: flex;
      justify-content: space-between;
      padding: 16px 36px 0 25px;
      li {
        display: flex;
        font-size: 16rem;
        font-weight: 400;
        color: #666666;
        margin-bottom: 15px;
        .name {
          // font-size: 18rem;
          margin-right: 20px;
        }
      }
      .up-right {
        padding: 0px 0 0 35px;
        #logo {
          border-radius: 4px;
          width: 84px;
          height: 84px;
          background-color:#ffffff;
          margin-bottom: 8px;
        }
        img {
          border-radius: 4px;
          width: 84px;
          height: 84px;
        }
        .el-button {
          width: 84px;
          height: 32px;
          font-size: 16rem;
          padding: 0;
        }
      }
    }
  }

  .first-below {
    text-align: center;
    margin: auto;
    font-size: 14rem;
    font-weight: 400;
    color: #666666;
    margin-top: 10%;
    cursor: pointer;
  }
  .first-below:hover {
    color: #0d94ff;
  }
}
::v-deep .el-dropdown-link:focus {
  outline: none;
}


.el-dropdown-link {
  cursor: pointer;
  display: flex;
  line-height: 20px;
  align-items: center;
  font-size: 18rem;
  .oImg {
    width: 36rem;
    height: 36rem;
    border-radius: 50%;
    margin-left: 31rem;
    margin-right: 7rem;
  }
  img {
    width: 36rem;
    height: 36rem;
    border-radius: 50%;
  }
}

.colorthree {
  position: fixed;
  width: 0;
  height: 0;
  border: 8px solid;
  border-color: transparent transparent #fff;
  top: 4.2%;
  right: 3%;
}

#pane-second {
  //  margin-top: 20rem  !important;
  height: auto;
}
#btn {
  width: 96px !important;
  height: 32rem !important;
  margin-top: 18rem;
  line-height: 6rem;
  // text-align: center;
}
.logo-btn {
  background-color: rgba(255, 254, 254, 0.856);
  border: 1px solid rgba(0, 0, 0, 0.15);
  color: #333333;
  font-size: 14rem;
  border-radius: 2rem;
  font-weight: 400;
  // margin-top: 20rem;
}

</style>
